export default "__VITE_ASSET__DDsSxZAT__"